import { Button, Card, Flex, Form, Input, message, Select } from "antd";
import { useNavigate } from "react-router-dom";
import styled from "styled-components";
import { Platform } from "../shared/types/enums";
import { call } from "../tsrpc";

const PageShell = styled.div`
  width: 100%;
  height: 100%;
  display: grid;
  place-items: center;
  overflow-y: auto;
  padding: 24px 16px;
`;

const AuthCard = styled(Card)`
  width: min(480px, 100%);
`;

const MForm = styled(Form)`
  width: 100%;
`;

export default function PageRegister() {
  const navigate = useNavigate();
  const [messageApi, contextHolder] = message.useMessage();

  const onRegister = async (values: any) => {
    const res = await call("Register", {
      timestamp: Date.now(),
      data: {
        username: values.username,
        password: values.password,
        platform: values.platform,
        email: values.email,
        phone: values.phone,
        nickname: values.nickname,
        role: values.role,
      },
    });
    if (res.isSucc) {
      localStorage.setItem("username", values.username);
      navigate("/login");
    } else messageApi.error(res.err.message);
  };

  return (
    <PageShell>
      {contextHolder}
      <AuthCard title="注册">
        <MForm
          name="login"
          labelCol={{ span: 6 }}
          labelAlign="left"
          initialValues={{
            platform: Platform.editor,
            role: "admin",
          }}
          onFinish={onRegister}
        >
          <Form.Item
            name="username"
            label="用户名"
            rules={[
              { required: true, message: "请输入用户名！" },
              { pattern: /^[a-zA-Z0-9_-]{4,20}$/, message: "用户名格式错误！" },
            ]}
          >
            <Input allowClear maxLength={20} showCount />
          </Form.Item>
          <Form.Item
            name="password"
            label="密码"
            rules={[
              { required: true, message: "请输入密码！" },
              { pattern: /^[a-zA-Z0-9_-]{6,20}$/, message: "密码格式错误！" },
            ]}
          >
            <Input.Password allowClear />
          </Form.Item>
          <Form.Item
            name="password2"
            label="确认密码"
            dependencies={["password"]}
            rules={[
              { required: true, message: "请输入密码！" },
              ({ getFieldValue }) => ({
                validator(_, value) {
                  if (!value || getFieldValue("password") === value)
                    return Promise.resolve();
                  return Promise.reject("两次密码输入不一致！");
                },
              }),
            ]}
          >
            <Input.Password allowClear />
          </Form.Item>
          <Form.Item name="platform" hidden>
            <Select
              options={[
                { label: "编辑器", value: Platform.editor },
                { label: "浏览器", value: Platform.browser },
                { label: "微信小程序", value: Platform.wecaht },
                { label: "抖音小程序", value: Platform.douyin },
              ]}
            />
          </Form.Item>
          <Form.Item name="nickname" label="昵称">
            <Input allowClear maxLength={20} showCount />
          </Form.Item>
          <Form.Item
            name="email"
            label="邮箱"
            rules={[
              {
                pattern: /^[a-zA-Z0-9_-]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/,
                message: "邮箱格式错误！",
              },
            ]}
          >
            <Input allowClear maxLength={20} showCount />
          </Form.Item>
          <Form.Item
            name="phone"
            label="手机号"
            rules={[{ pattern: /^1[3-9]\d{9}$/, message: "手机号格式错误！" }]}
          >
            <Input allowClear maxLength={11} showCount />
          </Form.Item>
          <Form.Item name="role" label="角色">
            <Select
              options={[
                { label: "玩家", value: "player" },
                { label: "游戏管理员", value: "gm" },
                { label: "管理员", value: "admin" },
                { label: "超级管理员", value: "superadmin", disabled: true },
              ]}
            />
          </Form.Item>
          <Form.Item>
            <Flex gap={10}>
              <Button onClick={() => navigate("/")}>返回</Button>
              <Button type="primary" htmlType="submit" block>
                注册
              </Button>
            </Flex>
          </Form.Item>
        </MForm>
      </AuthCard>
    </PageShell>
  );
}
